import { Endpoint } from './base/endpoints';
import { useBaseService } from './base/useBaseService';

export default function useFacets(setId: string, itemId: string) {
  const facetService: any = useBaseService(
    {
      // facets will be invalidated on the items endpoint as they can only be got from items
      queryKey: ['items', setId],
      endpoints: {
        create: Endpoint.addFacet,
        delete: Endpoint.deleteFacet,
        order: Endpoint.orderFacet,
        update: Endpoint.updateFacet,
      },
    },
    setId
  );

  return {
    ...facetService,
    data: itemId ? facetService.data.find((i) => i.id === itemId)?.facets : facetService.data,
    liveData: () => (itemId ? facetService.liveData().find((i) => i.id === itemId)?.facets : facetService.liveData),
  };
}
